var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.698,
    height: 10.701,
    viewBox: "0 0 10.698 10.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-search",
    "data-name": "Icon ionic-ios-search",
    d: "M13.073,12.422l-2.975-3a4.24,4.24,0,1,0-.644.652l2.956,2.984a.458.458,0,0,0,.646.017A.461.461,0,0,0,13.073,12.422ZM6.765,10.107a3.348,3.348,0,1,1,2.368-.981A3.327,3.327,0,0,1,6.765,10.107Z",
    transform: "translate(-2.5 -2.496)",
    fill: "#185cff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageSearch);
export default __webpack_public_path__ + "static/media/manage-search.dfe88b66bdcdacd38b7fc4ab3411c362.svg";
export { ForwardRef as ReactComponent };